import { Component, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { TabsModule } from "@openng/optimus-ui/tabs";
import { GlobalStatisticsComponent } from "./components/global-statistics/global-statistics.component";
import { HumidityStatisticsComponent } from "./components/humidity-statistics/humidity-statistics.component";

@Component({
  standalone: true,
  selector: "app-statistics",
  imports: [TranslateModule, TabsModule, GlobalStatisticsComponent, HumidityStatisticsComponent],
  templateUrl: "./statistics.component.html",
  styleUrl: "./statistics.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [],
})
export class StatisticsComponent {
  @ViewChild(HumidityStatisticsComponent)
  humidityStats?: HumidityStatisticsComponent;
  @ViewChild(GlobalStatisticsComponent) globalStats?: GlobalStatisticsComponent;

  activeTab = 0;

  onTabChange(newTab: string | number | undefined) {
    if (this.activeTab === 0) {
      this.globalStats?.statisticsFacade.destroy();
      const asset = this.humidityStats?.selectedAsset();
      if (asset) {
        this.humidityStats?.humidityStatisticsFacade.loadInitialState(asset.id, asset.assetType);
      }
    }
    if (this.activeTab === 1) {
      this.humidityStats?.humidityStatisticsFacade.cleanup();
      this.globalStats?.ngOnInit();
    }
    this.activeTab = Number(newTab);
  }
}
